/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Reviews_Topcriticaverage3Inputs */

const id_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rata-rata Kritikus Teratas`)
};

const ms_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purata Pengkritik Teratas`)
};

const da_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Kritiker Gennemsnit`)
};

const de_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top-Kritiker-Durchschnitt`)
};

const en_us2_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Critic Average`)
};

const es_es2_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promedio de críticos principales`)
};

const es_mx2_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promedio de críticos principales`)
};

const fil_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Average ng Nangungunang Kritiko`)
};

const fr_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moyenne des critiques`)
};

const it_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media critici principali`)
};

const hu_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legjobb kritikusok átlaga`)
};

const nl_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topcriticus gemiddelde`)
};

const no_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toppkritiker gjennomsnitt`)
};

const pl_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Średnia głównych krytyków`)
};

const pt_br2_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Média da crítica superior`)
};

const pt_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Média dos melhores críticos`)
};

const ro_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medie critici de top`)
};

const fi_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parhaiden kriitikoiden keskiarvo`)
};

const sv_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toppkritikernas genomsnitt`)
};

const vi_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điểm trung bình nhà phê bình`)
};

const tr_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En İyi Eleştirmen Ortalaması`)
};

const cs_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Průměr top kritiků`)
};

const bg_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Средна оценка на топ критиците`)
};

const ru_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Средний балл топ-критиков`)
};

const uk_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Середній бал критиків`)
};

const ar_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متوسط تقييم النقاد`)
};

const hi_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टॉप क्रिटिक औसत`)
};

const th_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คะแนนเฉลี่ย Top Critic`)
};

const ja_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トップ批評家平均`)
};

const zh_cn2_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`顶级媒体平均分`)
};

const zh_hant1_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`頂級媒體平均分`)
};

const ko_offerdetail_reviews_topcriticaverage3 = /** @type {(inputs: Offerdetail_Reviews_Topcriticaverage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주요 비평가 평균`)
};

/**
* | output |
* | --- |
* | "Top Critic Average" |
*
* @param {Offerdetail_Reviews_Topcriticaverage3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_reviews_topcriticaverage3 = /** @type {((inputs?: Offerdetail_Reviews_Topcriticaverage3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Reviews_Topcriticaverage3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "ms") return ms_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "da") return da_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "de") return de_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "en-US") return en_us2_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "fil") return fil_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "fr") return fr_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "it") return it_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "hu") return hu_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "nl") return nl_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "no") return no_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "pl") return pl_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "pt") return pt_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "ro") return ro_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "fi") return fi_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "sv") return sv_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "vi") return vi_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "tr") return tr_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "cs") return cs_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "bg") return bg_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "ru") return ru_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "uk") return uk_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "ar") return ar_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "hi") return hi_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "th") return th_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "ja") return ja_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_reviews_topcriticaverage3(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_reviews_topcriticaverage3(inputs)
	return ko_offerdetail_reviews_topcriticaverage3(inputs)
});
export { offerdetail_reviews_topcriticaverage3 as "offerDetail.reviews.topCriticAverage" }